import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class SystemMessageStartModuleViewModel {
    SystemMessages = ko.observableArray<{
        SystemMessage: string;
    }>([]);
    private Parent: any;
    constructor(parent) {
        this.Parent = parent;
        parent.Refresh = () => {
            return this.init();
        };
    }
    init() {
        return Bao.post("SystemMessage/GetSystemMessagesForDashboard").then((result) => {
            this.SystemMessages(result);
        });
    }
    loaded() {
        return $.Deferred().resolve().promise();
    }
}
export default SystemMessageStartModuleViewModel;